import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from '../../../services/settings.service';
import { map } from "rxjs/operators";
import { DatePipe } from "@angular/common";
import { Object } from "ol";

@Injectable({
  providedIn: 'root'
})
export class SolicitudCreditoService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService,
    //private datePipe: DatePipe,
  ) { }

  obtenerListaSolicitudCredito(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'solicitud/credito/list', filtro);
  }
  obtenerListaSolicitudCreditoRechazado(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'solicitud/credito/rechazado', filtro);
  }
  obtenerDetalleSolicitudCredito(solicitudCreditoId: any) {
    return this.http.get(this.settings.URL_BASE + 'solicitud_credito/' + solicitudCreditoId + '/detalle');
  }

  obtenerListaSolicitudPorPersona(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'solicitud/credito/persona', filtro);
  }

  /**
   * Método para obtener la lista de los medio de solicitud de crédito
   * @returns lista de medio de solicitud de crédito
   */
  obtenerListaMedioSolicitudCredito(cantidad = 20) {
    return this.http.get(this.settings.URL_BASE + 'public/solicitud_credito_medio_ingreso' + (cantidad ? '?cantidad=' + cantidad : ''));
  }

  /**
   *
   * @param filtro parametro para filtro
   * @returns Retorna la lista de clientes que recibieron incentivos
   */
  obtenerListaSolicitudCreditoSoporte(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'solicitud/credito/listar', filtro);
  }

  /**
   * Método para obtener la lista de los estaddos de solicitud de crédito
   * @returns lista de estados de solicitud de crédito
   */
  obtenerListaEstaddoSolicitudCredito(cantidad = 20) {
    return this.http.get(this.settings.URL_BASE + 'public/solicitud_credito_estado' + (cantidad ? '?cantidad=' + cantidad : ''));
  }
  /**
   * Método para obtener la lista de los tipos de producto de solicitud de crédito
   * @returns lista de tipos de producto de solicitud de crédito
   */
  obtenerListaTipoProductoSolicitudCredito() {
    return this.http.get(this.settings.URL_BASE + 'binder/configuracion/lista_productos');
  }

  actualizarEstadoSolicitudCredito(id: any, data: any): Observable<any> {
    return this.http.put(this.settings.URL_BASE + 'solicitud/credito/rechazado/' + id, data);
  }


  obtenerListaReporteDatosAdicionales(filtro: any) {
    return this.http.post(this.settings.URL_BASE + 'solicitud/credito/datos/adicionales', filtro);
  }

  /**
   * Método para obtener los tips de solicitudes de creditos
   * @returns lista de tipos de solicitud de creditos
   */
  obtenerTipSolicitudCreditoAdicionales(cantidad = 20) {
    return this.http.get(this.settings.URL_BASE + 'solicitud/credito/datos/adicionales/tipos');
  }



  exportarCSV(filtro: any) {
    return this.http.post(`${this.settings.URL_BASE}solicitud/credito/datos/adicionales`, filtro).pipe(
      map((resp: any) => {
        return resp['data'].map(item => {
          // Verificar si item.response es un array
          let respuesta = Array.isArray(item['response']) ? item['response'].join(' / ') : item['response'];

          // Convertir respuesta a una cadena de texto si es un objeto o está vacío
          if (typeof respuesta === 'object' || !respuesta) {
            respuesta = respuesta ? 'Sin datos' : JSON.stringify(respuesta);
          }

          return {
            id: item['id'],
            nombre: item['nombre'],
            documento: item['documento'],
            codigo_cliente: item['codigoCliente'],
            estado_solicitud: item['estadoSolicitud'],
            numero_solicitud: item['numeroSolicitud'],
            fecha_solicitud: item['fechaSolicitud'],
            tipo_dato_adicionales: item['tipoDatosAdicionales'],
            solicitud: item['request'].join(' / '),
            respuesta: respuesta
          }
        })
      })
    );
  }


  /**
   * Función para solicitar anulación de una solicitud de crédito
   * @param data datos de la solicitud de anulación
   * @returns observable que contiene la respuesta del servidor
   */
  solicitarAnulacion(data: any) {
    return this.http.post<any>(`${this.settings.URL_BASE}solicitud/credito/anulacion/save`, data);
  }

  getContrato(solicitudId: any) {
    return this.http.get(`${this.settings.URL_BASE}solicitud/credito/${solicitudId}/contrato/digital`,
      { responseType: 'blob' }
    );
  }

  getUsurpacion(solicitudId: any) {
    return this.http.get<any>(
      `${this.settings.URL_BASE}reporte/solicitud/credito/${solicitudId}/aceptacion/terminos/condiciones`);
  }


}
